var map = {
	"./angular.png": 9720,
	"./bootstrap.png": 8506,
	"./c++.png": 7554,
	"./c.png": 739,
	"./css.png": 1730,
	"./express.png": 7301,
	"./git.png": 7629,
	"./graphql.png": 782,
	"./html.png": 2602,
	"./java.png": 8058,
	"./javascript.png": 5410,
	"./jquery.png": 4180,
	"./matplotlib.png": 11,
	"./mongodb.png": 7154,
	"./mysql.png": 7010,
	"./nextjs.png": 7933,
	"./node.png": 6055,
	"./numpy.png": 1313,
	"./pandas.png": 3892,
	"./php.png": 6456,
	"./postgres.png": 4330,
	"./postman.png": 1059,
	"./python.png": 7972,
	"./react.png": 5671,
	"./scikit.png": 9873,
	"./tailwind.png": 836,
	"./typescript.png": 9101,
	"./uipath.png": 7518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4725;